import DataGrid from 'components/DataGrid/DataGrid';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
import { trimEmptyStringsFromQuery } from 'helpers/helpers';
import makeStyles from '@material-ui/styles/makeStyles';

const dateFormat = 'YYYY-MM-DD';

import columnConfig from './columnConfig';

const useStyles = makeStyles(() => ({
  description: {
    marginTop: '-12px',
    marginBottom: '18px',
  },
}));

const now = new Date();
const tomorrowMidnight = new Date(
  now.getFullYear(),
  now.getMonth(),
  now.getDate() + 1
);

const EcommerceBagCurrent = () => {
  const { t } = useTranslation();

  const classes = useStyles();

  return (
    <>
      <div className={classes.description}>
        <Trans
          i18nKey="ecommerceBags.current.description"
          components={{ b: <b /> }}
          values={{
            dateFrom: moment(tomorrowMidnight)
              .subtract(14, 'days')
              .format('DD.MM.YYYY'),
            lastUpdate: moment().format('HH:mm'),
          }}
        />
      </div>
      <DataGrid
        remove={true}
        export={true}
        noRefresh={true}
        paginationTop={true}
        paginationBottom={false}
        url="/bags"
        reportName="bag"
        columns={columnConfig(t)}
        role="BAG"
        minRows={20}
        defaultHiddenColumns={[
          'clientDiet.order.id',
          'clientDiet.isSubscription',
          'hasAddons',
          'address.city',
          'address.zone.name',
          'clientDiet.diet.name',
          'clientDiet.variant.name',
          'clientDiet.calorific.name',
          'clientDiet.optionChangeMenu',
          'clientDiet.useEcoContainers',
        ]}
        defaultFiltered={[
          {
            id: 'date',
            value: {
              after: moment().format(dateFormat),
              before: moment().format(dateFormat),
            },
          },
          {
            id: 'clientDiet.active',
            value: true,
          },
          {
            id: 'clientDiet.order.status.systemValue',
            value: 'PAID',
          },
        ]}
        manipulateQuery={(requestData, query) => {
          // eslint-disable-next-line no-underscore-dangle
          query._orX = [];
          if (query.user) {
            // eslint-disable-next-line no-underscore-dangle
            query._orX.push([
              {
                'clientDiet.client.firstName': query.user.split(' '),
                'clientDiet.client.lastName': query.user.split(' '),
              },
            ]);
            delete query.user;
          }
          if (query.date) {
            const { after, before } = query.date;
            if (after) {
              query['date[after]'] = moment(after).format(dateFormat);
            }
            if (before) {
              query['date[before]'] = moment(before).format(dateFormat);
            }
            delete query.date;
          }

          if (query.deliveredAt) {
            const { after, before } = query.deliveredAt;
            if (after) {
              query['deliveredAt[after]'] = after;
            }
            if (before) {
              query['deliveredAt[before]'] = before;
            }
            delete query.deliveredAt;
          }
          if (query.address) {
            const search = query.address;
            delete query.address;
            let splicedSearch = search.split(' ');
            splicedSearch = trimEmptyStringsFromQuery(splicedSearch);
            // eslint-disable-next-line no-underscore-dangle
            query._orX.push([
              {
                'address.city': splicedSearch,
                'address.street': splicedSearch,
                'address.postCode': splicedSearch,
                'address.buildNumber': splicedSearch,
                'address.placeNumber': splicedSearch,
                'address.pickUpPoint': splicedSearch,
              },
            ]);
            delete query.address;
          }

          return query;
        }}
      />
    </>
  );
};

export default EcommerceBagCurrent;
